import { NgModule } from '@angular/core';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { ContextService } from './services/context.service';

// Bridges avec la partie angular

@NgModule({
	imports: [
	],
	providers: [
		ContextService,
	],
	declarations: [
	],
	exports: [
	]
})
export class ContextModule {
	constructor() { }
}